import Vue from 'vue';

const ModulesBus = new Vue();

export default ModulesBus;
